<template>
  <component :is="tag" v-bind="tagAttributes" :class="cssClass" @click="click">
    <IconDefault
      v-if="iconLeft"
      :fill="iconColor"
      :type="iconLeft"
      class="c-btn-rectangle__icon"
    />
    <span><slot></slot></span>
    <IconDefault
      v-if="iconRight"
      :fill="iconColor"
      :type="iconRight"
      class="c-btn-rectangle__icon"
    />
  </component>
</template>

<script>
import IconDefault from '@/components/icon/IconDefault';
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    href: {
      type: String,
      required: false
    },
    iconColor: {
      type: String,
      required: false
    },
    iconLeft: {
      type: String,
      required: false
    },
    iconRight: {
      type: String,
      required: false
    },
    priority: {
      type: String,
      required: false,
      default: 'middle'
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    target: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: 'button'
    },
    to: {
      type: Object,
      required: false
    },
    isLoading: {
      type: Boolean,
      required: false
    }
  },
  components: {
    IconDefault
  },
  computed: {
    cssClass() {
      return {
        'c-btn-rectangle': true,
        ['c-btn-rectangle--' + this.size]: this.size,
        ['c-btn-rectangle--' + this.priority]: this.priority,
        'is-loading': this.isLoading
      };
    },
    tag() {
      if (!this.disabled) {
        if (this.href) {
          return 'a';
        } else if (this.to) {
          return 'router-link';
        }
      }
      return 'button';
    },
    tagAttributes() {
      switch (this.tag) {
        case 'a':
          return {
            href: this.href,
            target: this.target
          };
        case 'router-link':
          return {
            to: this.to,
            target: this.target
          };
        default:
          return {
            type: this.type,
            disabled: this.disabled
          };
      }
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    }
  }
};
</script>
